import React, { useState } from 'react';
import { Modal } from 'reactstrap';

const EditMyCoverModal = ({ modal, toggle, basic }) => {
    return (
    <Modal isOpen={modal} toggle={toggle}>        
        <div className="d-flex pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
            <div className="modal-header">Edit Profile Photo</div>
            <div className="f-right" style={{marginLeft:'auto'}}>
                <i className="fas fa-times modal-close" onClick={toggle}></i>
            </div>
        </div>   
        <hr className="mg-r-0"></hr>
        <div className="modal-block">
            
            <button className="btn btn-success-lite mg-r-15">Reset</button> 
            <button className="btn btn-primary-lite mg-r-15">Save</button>
            <button className="btn btn-danger-lite" onClick={toggle}>Cancel</button>
        </div>          
    </Modal>
)}
export default EditMyCoverModal;